import { render, staticRenderFns } from "./MT4.vue?vue&type=template&id=54f1cc2d&scoped=true"
import script from "./MT4.vue?vue&type=script&lang=js"
export * from "./MT4.vue?vue&type=script&lang=js"
import style0 from "./MT4.vue?vue&type=style&index=0&id=54f1cc2d&prod&scoped=true&lang=css"
import style1 from "./MT4.vue?vue&type=style&index=1&id=54f1cc2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f1cc2d",
  null
  
)

export default component.exports